export default "__VITE_ASSET__DDQRunzw__"